// extracted by mini-css-extract-plugin
export default {"body":"NewsLetter_body__kkJgL","body_inner":"NewsLetter_body_inner__W6L4d","body_title":"NewsLetter_body_title__H3b6F","button":"NewsLetter_button__T9LBW"};